// Decide dacă un item din meniu trebuie marcat ca activ pentru ruta curentă,
// incluzând sub-rutele (ex. /candidates/:id, /job/:id) ca să rămână evidențiat.
export const isNavItemActive = (pathname: string, id: string): boolean => {
    const p = pathname.toLowerCase()
    switch (id) {
        case "home":
            return p === "/" || p === "/home"
        case "candidates":
            return p.startsWith("/candidates") || p.startsWith("/applications")
        case "jobs":
            return p.startsWith("/jobs") || p.startsWith("/job") || p.startsWith("/post-job")
        case "events":
            return p.startsWith("/events")
        case "notifications":
            return p.startsWith("/notifications")
        case "credits":
            return p.startsWith("/credits")
        case "settings":
            return p.startsWith("/settings") || p.startsWith("/subscription")
        default:
            return false
    }
}
